import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=cec37036&scoped=true"
import script from "./Resources.vue?vue&type=script&setup=true&lang=ts"
export * from "./Resources.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec37036",
  null
  
)

export default component.exports